"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4837],{

/***/ 20841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);
/* harmony import */ var segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51261);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    textAlign: "left",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG
}));


/***/ }),

/***/ 66442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var segments_desktop_core_components_title_only_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20841);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91841);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77869);




var _obj;
/* harmony default export */ __webpack_exports__["Z"] = (_obj = {
    children: [],
    defaultActiveTabIndex: 0,
    autoTransition: "10000",
    theme: "gradiant-gray",
    title: segments_desktop_core_components_title_only_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    tabsColor: "iris",
    tabs: [
        {
            tabLabel: "Tab 1",
            textAndAsset: segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        },
        {
            tabLabel: "Tab 2",
            textAndAsset: segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        },
        {
            tabLabel: "Tab 3",
            textAndAsset: segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        },
        {
            tabLabel: "Tab 4",
            textAndAsset: segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        },
        {
            tabLabel: "Tab 5",
            textAndAsset: segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        },
        {
            tabLabel: "Tab 6",
            textAndAsset: segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        }
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_2__.MD
}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "autoTransition", null), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "backgroundColor", "white"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "minHeight", "600px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "addTimeline", false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "addTabIndicator", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "fullBackground", false), _obj);


/***/ }),

/***/ 54837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VerticalTabs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs.scss.js

var StyledVerticalTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e62vuw20"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:991px){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/default-props.js
var default_props = __webpack_require__(66442);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./static/svg/arrow-right-v2.svg
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRightV2 = function SvgArrowRightV2(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 15,
        viewBox: "0 0 14 15"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#000",
        strokeWidth: 2
    }, /*#__PURE__*/ react.createElement("path", {
        d: "m6.657 1.75 5.657 5.657-5.657 5.657"
    }), /*#__PURE__*/ react.createElement("path", {
        strokeLinecap: "square",
        d: "M11 7.407H1"
    }))));
};
/* harmony default export */ var arrow_right_v2 = (SvgArrowRightV2);

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/tabs/tabs.scss.js


var StyledTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19133ka0"
})("display:flex;justify-content:center;.tabs{display:flex;padding-top:64px;width:200px;flex-shrink:0;.tabs-wrapper{display:flex;flex-direction:column;position:relative;width:100%;.selected-tab-indicator-component{position:absolute;display:flex;align-items:center;justify-content:center;right:-16px;transition:transform 300ms ease;z-index:1;.selected-tab-indicator{height:32px;width:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;g{stroke:", colors/* default.white */.Z.white, ";}}}}}.content{display:flex;flex-grow:1;padding:64px 0px;border-radius:4px;padding-bottom:0;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/constants.js
/* harmony default export */ var constants = ({
    TAB_HEIGHT: 40
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/tabs/tabs.js











var Tabs = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Tabs, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Tabs);
    function Tabs(props) {
        (0,_class_call_check/* default */.Z)(this, Tabs);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            activeTabIndex: props.defaultActiveTabIndex || _this.getNextActiveTab()
        };
        _this.handleTabClick = _this.handleTabClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(Tabs, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var autoTransition = this.props.autoTransition;
                if (autoTransition) this.playAutoTransition();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._changeActiveIndexInterval) clearInterval(this._changeActiveIndexInterval);
            }
        },
        {
            key: "getNextActiveTab",
            value: function getNextActiveTab(activeTabIndex) {
                var children = this.props.children;
                var currentIndex = activeTabIndex ? activeTabIndex + 1 : 0;
                for(var i = currentIndex; i < children.length + currentIndex; i++){
                    var tabIndex = i % children.length;
                    var tab = children[i % children.length];
                    if (!tab.props.isDisabled) {
                        return tabIndex;
                    }
                }
            }
        },
        {
            key: "playAutoTransition",
            value: function playAutoTransition() {
                var _this = this;
                var autoTransition = this.props.autoTransition;
                this._changeActiveIndexInterval = setInterval(function() {
                    var activeTabIndex = _this.state.activeTabIndex;
                    _this.setState({
                        activeTabIndex: _this.getNextActiveTab(activeTabIndex)
                    });
                }, autoTransition);
            }
        },
        {
            key: "handleTabClick",
            value: function handleTabClick(index) {
                var children = this.props.children;
                if (children[index].props.isDisabled) return;
                if (this._changeActiveIndexInterval) clearInterval(this._changeActiveIndexInterval);
                this.setState({
                    activeTabIndex: index
                });
            }
        },
        {
            key: "contentRenderer",
            value: function contentRenderer() {
                var children = this.props.children;
                var activeTabIndex = this.state.activeTabIndex;
                if (children[activeTabIndex]) {
                    return children[activeTabIndex].props.children;
                }
            }
        },
        {
            key: "tabsRenderer",
            value: function tabsRenderer() {
                var _this = this;
                var children = this.props.children;
                var activeTabIndex = this.state.activeTabIndex;
                return children.map(function(child, index) {
                    return /*#__PURE__*/ (0,react.cloneElement)(child, {
                        onClick: _this.handleTabClick,
                        index: index,
                        isActive: index === activeTabIndex
                    });
                });
            }
        },
        {
            key: "renderSelectedTabIndicator",
            value: function renderSelectedTabIndicator() {
                var activeTabIndex = this.state.activeTabIndex;
                var color = this.props.color;
                var top = activeTabIndex * constants.TAB_HEIGHT;
                var transform = "translateY(".concat(top, "px)");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "selected-tab-indicator-component",
                    style: {
                        transform: transform,
                        height: constants.TAB_HEIGHT
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selected-tab-indicator",
                        style: {
                            backgroundColor: colors/* default */.Z[color]
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_v2, {})
                    })
                });
            }
        },
        {
            key: "getContentInlineStyle",
            value: function getContentInlineStyle() {
                var _props = this.props, minHeight = _props.minHeight, fullBackground = _props.fullBackground, backgroundColor = _props.backgroundColor, paddingAboveTabs = _props.paddingAboveTabs;
                return {
                    minHeight: minHeight,
                    background: !fullBackground && colors/* default */.Z[backgroundColor],
                    paddingTop: paddingAboveTabs
                };
            }
        },
        {
            key: "getTabsInlineStyle",
            value: function getTabsInlineStyle() {
                var paddingAboveTabs = this.props.paddingAboveTabs;
                return {
                    paddingTop: paddingAboveTabs
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, positionStyles = _props.positionStyles, addTabIndicator = _props.addTabIndicator;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
                    className: "vertical-tabs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tabs",
                            style: this.getTabsInlineStyle(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tabs-wrapper",
                                style: positionStyles,
                                children: [
                                    this.tabsRenderer(),
                                    addTabIndicator && this.renderSelectedTabIndicator()
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content",
                            role: "tab",
                            style: this.getContentInlineStyle(),
                            children: this.contentRenderer()
                        })
                    ]
                });
            }
        }
    ]);
    return Tabs;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/vertical-tabs-desktop-component.scss.js


var StyledVerticalTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1f69nx40"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding-left:32px;.vertical-tabs-title-wrapper{padding:32px 48px;text-align:center;}.side-by-side-text-and-asset{.full-paragraph-component-wrapper{align-self:", function(param) {
    var positionStyles = param.positionStyles;
    return (positionStyles === null || positionStyles === void 0 ? void 0 : positionStyles.alignItems) || "auto";
}, ";width:40%;}.image-wrapper{width:60%;}}");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/tab/tab.scss.js



var TAB_HEIGHT = "".concat(constants.TAB_HEIGHT, "px");
var StyledTab = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqikmpk0"
})("height:", TAB_HEIGHT, ";display:flex;align-items:center;cursor:pointer;font-size:0.875rem;&.active{color:", function(param) {
    var color = param.color;
    return colors/* default */.Z[color];
}, ";&.with-image{border-left:5px solid;border-color:var(--border-color);}}:hover{color:", function(param) {
    var color = param.color;
    return colors/* default */.Z[color];
}, ";outline:0;}&:first-child{.vertical-tab-timeline{border-radius:5px 5px 0px 0px;}}&:last-child{.vertical-tab-timeline{border-radius:0px 0px 5px 5px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/tab/default-props.js
/* harmony default export */ var tab_default_props = ({});

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/tab/tab.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}











var Tab = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Tab, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Tab);
    function Tab(props) {
        (0,_class_call_check/* default */.Z)(this, Tab);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "blurTab", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".vertical-tab")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "tabClickedAction", function() {
            var _props = _this.props, onClick = _props.onClick, index = _props.index, label = _props.label;
            BigBrain("track", bigbrain_event_types.TAB_CLICKED, {
                kind: label,
                info1: index
            });
            onClick(index);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "rednerWithImage", function() {
            var tabImage = _this.props.tabImage;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tab-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({}, tabImage))
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "rednerWithoutImage", function() {
            var _props = _this.props, label = _props.label, isActive = _props.isActive, color = _props.color, addTimeline = _props.addTimeline, lineColor = _props.lineColor;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    addTimeline && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "vertical-tab-timeline",
                        style: {
                            borderColor: isActive ? colors/* default */.Z[color] : colors/* default */.Z[lineColor] || colors/* default */.Z[color_consts.WHITE_COLOR_NAME]
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tab-label",
                        style: {
                            color: _this.getTabColor()
                        },
                        children: label
                    })
                ]
            });
        });
        _this.onTabClicked = _this.onTabClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.tabClickedAction);
        return _this;
    }
    (0,_create_class/* default */.Z)(Tab, [
        {
            key: "onTabClicked",
            value: function onTabClicked(e) {
                this.blurTab(e);
                this.tabClickedAction();
            }
        },
        {
            key: "getTabColor",
            value: function getTabColor() {
                var _props = this.props, disabledColor = _props.disabledColor, color = _props.color, isDarkTheme = _props.isDarkTheme, isDisabled = _props.isDisabled, isActive = _props.isActive;
                if (isDisabled && disabledColor) return colors/* default */.Z[disabledColor];
                return isActive ? colors/* default */.Z[color] : isDarkTheme ? colors/* default */.Z[color_consts.WHITE_COLOR_NAME] : colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR];
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, tabImage = _props.tabImage, isActive = _props.isActive, color = _props.color, theme = _props.theme, tabClassName = _props.tabClassName;
                var leftBorderColor = theme ? segments_service/* themes */.np[theme].background : "none";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, {
                    color: color,
                    className: classnames_default()("vertical-tab", (0,_define_property/* default */.Z)({
                        active: isActive,
                        "with-image": tabImage
                    }, tabClassName, tabClassName)),
                    onClick: this.onTabClicked,
                    role: "tab",
                    "aria-selected": isActive,
                    tabIndex: 0,
                    onKeyDown: this.onKeyDown,
                    style: {
                        "--border-color": leftBorderColor
                    },
                    children: [
                        !tabImage && this.rednerWithoutImage(),
                        tabImage && this.rednerWithImage()
                    ]
                });
            }
        }
    ]);
    return Tab;
}(react.PureComponent);

Tab.defaultProps = tab_default_props;

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-desktop/vertical-tabs-desktop-component.js




function vertical_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var VerticalTabsDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerticalTabsDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerticalTabsDesktopComponent);
    function VerticalTabsDesktopComponent() {
        (0,_class_call_check/* default */.Z)(this, VerticalTabsDesktopComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(VerticalTabsDesktopComponent, [
        {
            key: "tabsRenderer",
            value: function tabsRenderer() {
                var _props = this.props, tabs = _props.tabs, tabsColor = _props.tabsColor, addTimeline = _props.addTimeline, isDarkTheme = _props.isDarkTheme, lineColor = _props.lineColor, tabContentRenderer = _props.tabContentRenderer;
                return tabs.map(function(tab, index) {
                    var tabLabel = tab.tabLabel, textAndAsset = tab.textAndAsset, tabClassName = tab.tabClassName, isDisabled = tab.isDisabled, tabDisabledColor = tab.tabDisabledColor;
                    var titleSize = (textAndAsset || {}).titleSize;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                        tabClassName: tabClassName,
                        isDisabled: isDisabled,
                        label: tabLabel,
                        disabledColor: tabDisabledColor,
                        color: tabsColor,
                        addTimeline: addTimeline,
                        isDarkTheme: isDarkTheme,
                        lineColor: lineColor,
                        children: tabContentRenderer ? tabContentRenderer(tab) : /*#__PURE__*/ (0,react.createElement)(side_by_side_text_and_asset/* default */.Z, _object_spread_props(vertical_tabs_desktop_component_object_spread({}, textAndAsset), {
                            titleSize: titleSize || sizes.XS,
                            key: index
                        }))
                    }, tabLabel);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, titleSize = _props.titleSize, tabsColor = _props.tabsColor, tabsPosition = _props.tabsPosition, tabsTitleRenderer = _props.tabsTitleRenderer;
                var positionStyles = (0,images_grid_service/* getImagePositionStyles */.y)(tabsPosition);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVerticalTabsDesktopComponent, {
                    positionStyles: positionStyles,
                    className: "vertical-tabs-desktop-component",
                    children: [
                        tabsTitleRenderer ? tabsTitleRenderer() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vertical-tabs-title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, _object_spread_props(vertical_tabs_desktop_component_object_spread({}, title), {
                                titleSize: titleSize
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vertical-tabs-wrapper",
                            role: "tablist",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, _object_spread_props(vertical_tabs_desktop_component_object_spread({}, this.props), {
                                color: tabsColor,
                                positionStyles: positionStyles,
                                children: this.tabsRenderer()
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return VerticalTabsDesktopComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-mobile/vertical-tabs-mobile-component.scss.js


var StyledVerticalTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekw1qt60"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding:0px 24px;.vertical-tabs-mobile-title-wrapper{padding:0px 16px;margin-bottom:32px;text-align:center;}.tab-wrapper{margin-bottom:80px;.tab-label{font-size:1rem;display:flex;align-items:center;justify-content:center;.line{height:2px;flex-grow:1;}.text{flex-shrink:0;margin:0px 16px;font-weight:400;}}.tab-content{margin-top:32px;.paragraph-wrapper .paragraph-body{display:none !important;}.side-by-side-text-and-asset{.side-by-side-content{background-color:transparent !important;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs-mobile/vertical-tabs-mobile-component.js





function vertical_tabs_mobile_component_define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_mobile_component_define_property1(target, key, source[key]);
        });
    }
    return target;
}
function vertical_tabs_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function vertical_tabs_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        vertical_tabs_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var VerticalTabsMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerticalTabsMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerticalTabsMobileComponent);
    function VerticalTabsMobileComponent() {
        (0,_class_call_check/* default */.Z)(this, VerticalTabsMobileComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(VerticalTabsMobileComponent, [
        {
            key: "renderTabs",
            value: function renderTabs() {
                var _props = this.props, tabs = _props.tabs, tabsColor = _props.tabsColor;
                return tabs.map(function(tab, index) {
                    var tabLabel = tab.tabLabel, textAndAsset = tab.textAndAsset, tabClassName = tab.tabClassName, tabDisabledColor = tab.tabDisabledColor, isDisabled = tab.isDisabled;
                    var color = isDisabled && tabDisabledColor ? colors/* default */.Z[tabDisabledColor] : colors/* default */.Z[tabsColor];
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("tab-wrapper", (0,_define_property/* default */.Z)({}, tabClassName, tabClassName)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tab-label",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "line",
                                        style: {
                                            backgroundColor: color
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text",
                                        style: {
                                            color: color
                                        },
                                        children: tabLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "line",
                                        style: {
                                            backgroundColor: color
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tab-content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, vertical_tabs_mobile_component_object_spread_props(vertical_tabs_mobile_component_object_spread({}, textAndAsset), {
                                    titleSize: sizes.XS
                                }))
                            })
                        ]
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, titleSize = _props.titleSize;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVerticalTabsMobileComponent, {
                    className: "vertical-tabs-mobile-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vertical-tabs-mobile-title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, vertical_tabs_mobile_component_object_spread_props(vertical_tabs_mobile_component_object_spread({}, title), {
                                titleSize: titleSize
                            }))
                        }),
                        this.renderTabs()
                    ]
                });
            }
        }
    ]);
    return VerticalTabsMobileComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs.js




function vertical_tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}






var VerticalTabs = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerticalTabs, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerticalTabs);
    function VerticalTabs() {
        (0,_class_call_check/* default */.Z)(this, VerticalTabs);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(VerticalTabs, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVerticalTabs, {
                    className: "vertical-tabs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desktop-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalTabsDesktopComponent, vertical_tabs_object_spread({}, this.props))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalTabsMobileComponent, vertical_tabs_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return VerticalTabs;
}(react.PureComponent);

VerticalTabs.defaultProps = default_props/* default */.Z;


/***/ })

}]);